import styled from '@emotion/styled';
import { type CellRendererProps, colors, Text } from '@innovationdepartment/proxima-ui';
import { Link } from 'react-router';
import type { User, UserActionProps } from 'types/users';
import { formatDate } from 'utils';
import UsersActionMenu from './ActionMenu';

const Capitalize = styled.span`
  text-transform: capitalize;
`;

const BrandsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  * {
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
    text-decoration-color: ${colors.neutral80};
  }
`;

const userRowRender = ({ header, cell }: CellRendererProps<User & { menu: UserActionProps }>) => {
  switch (header) {
    case 'email': {
      return (
        <Text variant="table1Link" color="neutral100">
          {typeof cell === 'string' ? cell : null}
        </Text>
      );
    }
    case 'status': {
      return (
        <Text variant="table1Link" color="neutral100">
          {typeof cell === 'string' ? cell : null}
        </Text>
      );
    }
    case 'lastLoginAt': {
      if (typeof cell === 'string') {
        const formattedCell = (cell as unknown) instanceof Date ? formatDate(cell) : cell;
        return (
          <Text variant="table1Link" color="neutral100">
            {formattedCell}
          </Text>
        );
      }
      return null;
    }
    case 'menu': {
      if (typeof cell === 'object') return <UsersActionMenu menu={cell as UserActionProps} />;
      return null;
    }
    case 'associatedBrands': {
      return (
        <BrandsWrapper>
          {(cell as User['associatedBrands']).map(brand => (
            <Link key={brand.brandId} to={`/brand/${brand.brandId}`}>
              <Text variant="table1Link" color="neutral100">
                {brand.name}
              </Text>
            </Link>
          ))}
        </BrandsWrapper>
      );
    }
    default: {
      return (
        <Text variant="table1Link" color="neutral100">
          <Capitalize>{typeof cell === 'string' ? cell : null}</Capitalize>
        </Text>
      );
    }
  }
};

export default userRowRender;
